import { useState } from 'react';
import {
  AssetPortfolio,
  AssetPortfolioComponent,
  AssetPortfolioComponentCondition,
  AssetPortfolioComponentConditionType,
} from '../../type/AssetPortfolio.type';
import {
  ASSET_TYPE_OPTION_LIST,
  AssetType,
  LIABILITY_TYPE_OPTION_LIST,
  LiabilityType,
  OWNER_TYPE_OPTION_LIST,
  REPORT_ITEM_TYPE,
  REPORT_ITEM_TYPE_OPTION_LIST,
  ReportItemType,
  ReportOwnerType,
} from '../../../assetReport/type/AssetReport.type';

export interface EditAssetPortfolioComponentConditionListData {
  includeYn: boolean;
  componentConditionList: AssetPortfolioComponentCondition[];
  handleComponentConditionChange: (index: number, target: string, value: any) => void;
  handleDeleteComponentConditionClick: (index: number) => void;
}

const EditAssetPortfolioComponentConditionList = ({
  includeYn,
  componentConditionList,
  handleComponentConditionChange,
  handleDeleteComponentConditionClick,
}: EditAssetPortfolioComponentConditionListData) => {
  return (
    <>
      {componentConditionList.filter((condition) => condition.includeYn === includeYn).length == 0 && (
        <div className="mt-6">
          <div className="bg-gray-50 rounded-lg p-4 text-xs text-center text-gray-800">조건을 추가해주세요.</div>
        </div>
      )}
      {componentConditionList.map(
        (condition, index) =>
          condition.includeYn === includeYn && (
            <div className="space-y-3 h-28">
              <div className="grid grid-cols-3 gap-3 pl-6">
                <div className="relative">
                  <i className="fas fa-user absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <select
                    value={condition.ownerTypeCondition || ''}
                    onChange={(e) => handleComponentConditionChange(index, 'ownerTypeCondition', e.target.value)}
                    className="w-full pl-10 pr-4 py-3 bg-gray-50 border-none rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm appearance-none cursor-pointer"
                  >
                    <option value="">전체</option>
                    {OWNER_TYPE_OPTION_LIST.map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
                <div className="relative ">
                  <i className="fas fa-list absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <select
                    value={condition.reportItemTypeCondition || ''}
                    onChange={(e) => handleComponentConditionChange(index, 'reportItemTypeCondition', e.target.value)}
                    className="w-full pl-10 pr-4 py-3 bg-gray-50 border-none rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm appearance-none cursor-pointer"
                  >
                    <option value="">전체</option>
                    {REPORT_ITEM_TYPE_OPTION_LIST.map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
                <div className="relative">
                  <i className="fas fa-list absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                  <select
                    disabled={!condition.reportItemTypeCondition}
                    value={
                      condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET
                        ? condition.assetTypeCondition
                        : condition.liabilityTypeCondition
                    }
                    onChange={(e) =>
                      handleComponentConditionChange(
                        index,
                        condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET
                          ? 'assetTypeCondition'
                          : 'liabilityTypeCondition',
                        e.target.value,
                      )
                    }
                    className="w-full pl-10 pr-4 py-3 bg-gray-50 border-none rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm appearance-none cursor-pointer"
                  >
                    <option value="">전체</option>
                    {condition.reportItemTypeCondition &&
                      (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET
                        ? ASSET_TYPE_OPTION_LIST
                        : LIABILITY_TYPE_OPTION_LIST
                      ).map((option) => <option value={option.value}>{option.label}</option>)}
                  </select>
                  <i className="fas fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>
              <div className="relative pl-6">
                <i className="fas fa-search absolute left-9 top-1/2 -translate-y-1/2 text-gray-400"></i>
                <input
                  type="text"
                  value={condition.nameCondition || ''}
                  onChange={(e) => handleComponentConditionChange(index, 'nameCondition', e.target.value)}
                  className="w-full pl-10 pr-4 py-3 bg-gray-50 border-none rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500/20 text-sm"
                  placeholder="자산명을 입력하세요"
                />
              </div>

              <button className="relative bottom-28 h-10" onClick={() => handleDeleteComponentConditionClick(index)}>
                <i className="fas fa-times text-red-600 text-lg"></i>
              </button>
            </div>
          ),
      )}
    </>
  );
};

export default EditAssetPortfolioComponentConditionList;
